import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8012/api/v1';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

export const teamsApi = {
  getAll: () => api.get('/teams/'),
};

export const playersApi = {
  getAll: () => api.get('/players/'),
};

export const stopsApi = {
  getAll: () => api.get('/stops/'),
  getById: (id) => api.get(`/stops/${id}/`),
  unlock: (id, latitude, longitude) =>
    api.post(`/stops/${id}/unlock/`, { latitude, longitude }),
  complete: (id, teamId, proofPhotoUrl = '') =>
    api.post(`/stops/${id}/complete/`, { team_id: teamId, proof_photo_url: proofPhotoUrl }),
  uploadProof: (id, file, teamId) => {
    const form = new FormData();
    form.append('image', file);
    if (teamId) form.append('team_id', teamId);
    return api.post(`/stops/${id}/upload_proof/`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  adminList: (adminPassword) =>
    api.get('/stops/admin_list/', { params: { admin_password: adminPassword } }),
  // REST create / update / delete
  create: (fields, adminPassword) =>
    api.post('/stops/', { ...fields, admin_password: adminPassword }),
  update: (id, fields, adminPassword) =>
    api.patch(`/stops/${id}/`, { ...fields, admin_password: adminPassword }),
  delete: (id, adminPassword) =>
    api.delete(`/stops/${id}/`, { params: { admin_password: adminPassword } }),
  // Legacy field-by-field update (kept for compatibility)
  adminUpdate: (id, fields, adminPassword) =>
    api.post(`/stops/${id}/admin_update/`, { ...fields, admin_password: adminPassword }),
  submitAnswer: (id, teamId, answerText) =>
    api.post(`/stops/${id}/submit_answer/`, { team_id: teamId, answer_text: answerText }),
  adminAnswers: (adminPassword) =>
    api.get('/stops/admin_answers/', { params: { admin_password: adminPassword } }),
  uploadImage: (id, file, adminPassword) => {
    const form = new FormData();
    form.append('image', file);
    form.append('admin_password', adminPassword);
    return api.post(`/stops/${id}/upload_image/`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export const challengesApi = {
  getAll: () => api.get('/challenges/'),
  adminList: (adminPassword) =>
    api.get('/challenges/', { params: { admin_password: adminPassword } }),
  adminAnswers: (adminPassword) =>
    api.get('/challenges/admin_answers/', { params: { admin_password: adminPassword } }),
  create: (fields, adminPassword) =>
    api.post('/challenges/', { ...fields, admin_password: adminPassword }),
  update: (id, fields, adminPassword) =>
    api.patch(`/challenges/${id}/`, { ...fields, admin_password: adminPassword }),
  delete: (id, adminPassword) =>
    api.delete(`/challenges/${id}/`, { params: { admin_password: adminPassword } }),
  submitAnswer: (id, teamId, answerText) =>
    api.post(`/challenges/${id}/submit_answer/`, { team_id: teamId, answer_text: answerText }),
  complete: (id, teamId, proofPhotoUrl = '') =>
    api.post(`/challenges/${id}/complete/`, { team_id: teamId, proof_photo_url: proofPhotoUrl }),
  uploadProof: (id, file, teamId) => {
    const form = new FormData();
    form.append('image', file);
    if (teamId) form.append('team_id', teamId);
    return api.post(`/challenges/${id}/upload_proof/`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  uploadImage: (id, file, adminPassword) => {
    const form = new FormData();
    form.append('image', file);
    form.append('admin_password', adminPassword);
    return api.post(`/challenges/${id}/upload_image/`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export const scoreboardApi = {
  get: () => api.get('/scoreboard/'),
};

export const manualPointsApi = {
  getAll: (adminPassword) =>
    api.get('/manual-points/', { params: { admin_password: adminPassword } }),
  award: (teamId, points, reason, adminPassword) =>
    api.post('/manual-points/', { team_id: teamId, points, reason, admin_password: adminPassword }),
  remove: (id, adminPassword) =>
    api.delete('/manual-points/', { params: { id, admin_password: adminPassword } }),
};

export const adminApi = {
  resetScores: (adminPassword) =>
    api.post('/reset-scores/', { admin_password: adminPassword }),
};

export const settingsApi = {
  get: () => api.get('/settings/'),
  setEndTime: (endTime, adminPassword) =>
    api.post('/settings/', { end_time: endTime, admin_password: adminPassword }),
  setStopRadius: (radius, adminPassword) =>
    api.post('/settings/', { stop_radius: radius, admin_password: adminPassword }),
  setHidePoints: (hidePoints, adminPassword) =>
    api.post('/settings/', { hide_points: hidePoints, admin_password: adminPassword }),
  setHideScoreboard: (hideScoreboard, adminPassword) =>
    api.post('/settings/', { hide_scoreboard: hideScoreboard, admin_password: adminPassword }),
  setGoalStop: (stopId, adminPassword) =>
    api.post('/settings/', { goal_stop_id: stopId, admin_password: adminPassword }),
};

export default api;
